export default __webpack_public_path__ + "static/mask-d86278c676d3ef57987caca64915aa39.png";